import type { ProductUnit } from "@stockline/shared/types/inventory/product-unit"
import type { OfflineResourceConfig } from "../../../types"
import { PRODUCT_UNIT_TABLE } from "./db"

/**
 * Offline-first config for the `product_units` resource — the association
 * table behind ``Product.productUnits[]`` (embedded ref) is now a first-class
 * sync target so the ERP write path (M3 conversion sync → V2 push → SSE)
 * propagates per-row weight changes to every connected Dexie copy.
 *
 * Both the JWT-authenticated client push endpoint and the internal
 * service-to-service endpoint use the same client-facing URL pattern; the
 * frontend always hits the JWT path.
 */
export const productUnitConfig: OfflineResourceConfig<ProductUnit> = {
  name: "product-units",
  syncDisabled: false,
  endpoints: {
    full: "/api/v2/product-units",
    delta: "/api/v2/product-units/changes",
    push: "/api/v2/product-units/changes",
  },
  tableName: PRODUCT_UNIT_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    productId: "productId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
